<template>
	<ProjectDifferencesView :old="old" :current="current" :project-configuration="projectConfiguration"
		:project-configuration-loaded="projectConfigurationLoaded"/>
</template>

<script>
  import {Api} from "@/api";
  import {genericFormUtil} from "@/utils/genericFormUtil";
  import {Project} from "@/api/generated/Project";
  import ProjectDifferencesView from "@/view/logged/project/components/ProjectDifferencesView";

	export default {
    name: "ProjectLastVersionsDifferencesView",

    components: {ProjectDifferencesView},

    data() {
      return {
        old: {},
        current: {},
        projectId: this.$route.params.projectId,
        projectConfiguration: {},
        projectConfigurationLoaded: false,
      };
    },

    async created () {
      await Api.syncGet(this, "/project/configuration?projectId=".concat(this.projectId), successResponse => {
            this.projectConfiguration = successResponse;
            this.projectConfiguration.genericPartScheme = genericFormUtil.decodeSchema(this.projectConfiguration.genericPartScheme);
          },
          errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się wczytać konfiguracji projektu", errorResponse);
          }
      );

      Project.getLastVersionComparison(this, this.projectId, successResponse => {
            this.old = successResponse.old;
            this.current = successResponse.current;
            this.old.genericModel = genericFormUtil.decodeSchema(this.old.genericModel);
            this.current.genericModel = genericFormUtil.decodeSchema(this.current.genericModel);
            this.projectConfigurationLoaded = true;
          },
          errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się załadować wersji projektu", errorResponse);
          }
      );
    }
	};
</script>
